export const routes = {
  home: '/',
  onboarding: '/onboarding',
  offer: '/offer',
  offerSelection: '/offerSelection',
  redirectStep: '/m',
};

export default routes;
